import React from "react";

const StaffChat = () => {
  return <div>StaffChat</div>;
};

export default StaffChat;
